<script>
import forms from '@components/form/forms.json'
import partner from '@components/form/partner'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    name: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    user: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    next: {
      default() {
        return null
      },
    },
    // eslint-disable-next-line vue/require-prop-types
    previous: {
      default() {
        return null
      },
    },
    applicant: {
      type: String,
      default() {
        return 'main'
      },
    },
  },
  data() {
    return {
      form: {},
      formset: [],
      min: null,
      sec: null,
      totalSeconds: 0,
    }
  },
  watch: {
    name(oldVal, newVal) {
      if (oldVal !== newVal) {
        //  console.log(this.name)
        this.form = {}
        this.formset = {}
        this.form = forms[this.name]
        this.formset = forms[this.name].form
      }
    },
    applicant(oldVal, newVal) {
      if (oldVal !== newVal) {
        //  console.log(this.user)
        if (this.applicant === 'main') {
          this.form = forms[this.name]
          this.formset = forms[this.name].form
        } else {
          this.form = partner[this.name]
          this.formset = partner[this.name].form
        }
      }
    },
  },
  beforeDestroy() {
    this.form = {}
    this.forms = {}
    this.formset = {}
    //  var doc = this.$refs.mainForm
    //  if (doc !== undefined) doc.innerHTML = ''
  },
  beforeMount() {
    if (this.applicant === 'main') {
      this.form = forms[this.name]
      this.formset = forms[this.name].form
    } else {
      this.form = partner[this.name]
      this.formset = partner[this.name].form
    }
  },
  methods: {
    changeData(data) {
      // console.log(data)
    },
    getApplink(data) {
      //   console.log(data)
      this.$emit('click', data)
    },
  },
}
</script>
<template>
  <div ref="mainForm">
    <div :class="$style.breadCrumbWraper">
      <h4 class="FL">
        <span>{{ form.heading }}</span>
      </h4>
      <div class="clear"></div>
    </div>
    <div class="clear"></div>
    <!-- <div :class="$style.bodyContentBorder"></div> -->
    <div>
      <div v-for="(field, key) in formset" :key="key + form.heading">
        <Component
          :is="field.typeComponent"
          :api="field.api"
          :value="field.value"
          :options="field.options"
          :form="field.form"
          :user="user"
          :next="next"
          :previous="previous"
          @click="getApplink"
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
// breadcrumb
.breadCrumbWraper {
  padding: 15px 30px;
  border-bottom: 2px solid #f8f9f9;

  h4 {
    margin: 0;
    font-family: 'SourceSansProSemibold', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 25px;
    line-height: 29px;
    color: #455d73;
  }
  span {
    font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    font-weight: 600;
    line-height: 29px;
    color: #8c959f;
  }

  svg {
    font-size: 16px;
  }
}
// breadcrumb

@media (max-width: 767px) {
  .breadCrumbWraper {
    h4 {
      font-size: 20px;
      line-height: 24px;
    }
    span {
      font-size: 18px;
      line-height: 24px;
    }
  }
}
</style>
